module.exports = __webpack_public_path__ + "img/0S6A9628.50ef979a.jpg";